import React, { useCallback, useMemo } from "react";
import { View } from "react-native";
import { useMediaImage } from "@lookiero/sty-psp-ui";
import { OptionImage } from "../../../../atom/optionImage/OptionImage";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { useAnswersValidation } from "../../behaviours/useAnswersValidation";
import { style as skinQuestionItemStyle } from "./SkinQuestionItem.style";
const SkinQuestionItem = ({ question, questionParentId }) => {
    const cdnImageUrl = useMediaImage();
    const resizeMode = question.metadata.resizeMode || "cover";
    const backgroundColor = question.metadata.backgroundColor;
    const style = useMemo(() => skinQuestionItemStyle(), []);
    const { answer, onChange } = useAnswerForId({ id: questionParentId });
    const selected = Boolean(answer && answer.find((id) => id === question.id));
    const { validateMaxAnswers } = useAnswersValidation();
    const handleOnPress = useCallback(() => {
        onChange({ questionId: question.id, answer: selected ? undefined : question.id });
        validateMaxAnswers();
    }, [onChange, question.id, selected, validateMaxAnswers]);
    return (React.createElement(View, { style: style.container, testID: "skin-question-item" },
        React.createElement(OptionImage, { aspectRatio: 1, checked: selected, imageResizeMode: resizeMode, src: cdnImageUrl({ url: question.metadata.source, width: 400 }), testID: question.id, title: question.translationKey, value: question.translationKey, style: {
                image: [style.image, { backgroundColor }],
                icon: {
                    iconContainer: style.iconContainer,
                },
                container: style.imageContainer,
            }, onChange: handleOnPress })));
};
export { SkinQuestionItem };
